import React from 'react';
import { Row, Col } from 'bootstrap';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import Header from 'main/components/event/header.jsx';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import SpinnerConstants from 'shared/constants/Spinners';
import SpinnerContainer from 'shared/components/misc/spinnerContainer';
import EventViewActions from 'flux/actions/EventViewActions';
import ShowTemplateList from 'shared/components/event/showTemplateList';
import EventShowListActions from 'flux/actions/EventShowListActions';
import BreadcrumbBar from 'main/components/event/breadcrumbBar';

const ViewTypes = {
  Saved: 'saved',
  Templates: 'templates',
};

/**
 * HOC - shows that are templates or saved
 */
export default (viewType, archived) => {
  const List = ShowTemplateList(
    viewType === 'saved' ? 'savedShows' : 'showTemplates',
    archived,
  );

  return React.createClass({
    mixins: [PureRenderMixin],

    displayName: 'EventShowTemplatesPage_' + viewType,

    componentDidMount() {
      this._populate();
    },

    componentWillUpdate(nextProps) {
      let { teamId, eventId } = this.props.params,
        { teamId: nextTeamId, eventId: nextEventId } = nextProps.params;

      if (eventId !== nextEventId || teamId !== nextTeamId) {
        this._populate();
      }
    },

    _populate() {
      let { teamId, eventId } = this.props.params;
      EventViewActions.populate(teamId, eventId);
      EventShowListActions.populate(teamId, eventId);
    },

    render() {
      let { teamId, eventId } = this.props.params;

      let label = viewType === ViewTypes.Saved ? 'Saved' : 'Templates';

      let dashPickerIconNode = (
        <Icon name={viewType === ViewTypes.Saved ? 'save' : 'flag'} />
      );

      let dashPickerDisplayNode = (
        <span>
          {dashPickerIconNode} {label}
        </span>
      );

      return (
        <div>
          <SpinnerContainer name={SpinnerConstants.EventDash}>
            <Header />
            <h4 className="hidden-lg hidden-md text-center">{label}</h4>
            <Row>
              <BreadcrumbBar
                {...{ teamId, eventId }}
                content={
                  <div className="hidden-xs">
                    {dashPickerDisplayNode}&nbsp;&nbsp;&nbsp;
                  </div>
                }
              />
              <Col lg={24}>
                <List teamId={teamId} eventId={eventId} />
              </Col>
            </Row>
          </SpinnerContainer>
        </div>
      );
    },
  });
};
